import './_product-shipping-experience.scss';

export default () => {};
